export default __webpack_public_path__ + "static/media/bell-icon.957c1a54.svg";